import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import * as Form from 'components/_core/form';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Header from '../../../../components/Header';
import CapitalDepositQuestionPage from '../../components/QuestionPage';
import partnerNameSchema, {
  PartnerNameSchema,
} from '../../libs/partnerNameSchema';
import { CapitalDepositPage } from '../../types';
import locales from './locales';

const OPTIONS = [
  {
    label: 'Keobiz',
    value: 'Keobiz',
  },
  {
    label: 'LegalPlace',
    value: 'LegalPlace',
  },
  {
    label: 'Legalstart',
    value: 'Legalstart',
  },
  {
    label: 'Comptastar',
    value: 'Comptastar',
  },
  {
    label: 'Captain Contrat',
    value: 'Captain Contrat',
  },
  {
    label: 'Indy',
    value: 'Indy',
  },
  {
    label: 'Dougs',
    value: 'Dougs',
  },
  {
    label: 'Gojee',
    value: 'Gojee',
  },
  {
    label: 'Agence-Juridique.com',
    value: 'Agence-Juridique.com',
  },
  {
    label: 'Contract Factory',
    value: 'Contract Factory',
  },
  {
    label: 'Les Tricolores',
    value: 'Les Tricolores',
  },
  {
    label: locales.partnerOptions.lawyer,
    value: 'Un avocat',
  },
  {
    label: locales.partnerOptions.accountingFirm,
    value: 'Un cabinet d’expertise comptable',
  },
] as const;

export type CapitalDepositPartnerValue = (typeof OPTIONS)[number]['value'];

type CapitalDepositPartnerNameProps = {
  onSubmit: (values: PartnerNameSchema) => void;
  formData: Partial<PartnerNameSchema>;
  isSending: boolean;
} & CapitalDepositPage;

const CapitalDepositPartnerName = asBentoPage<CapitalDepositPartnerNameProps>(
  ({ formData, isSending, Layout, onPrev, onSubmit, progress }) => {
    const {
      control,
      formState: { isValid },
      handleSubmit,
    } = useForm<PartnerNameSchema>({
      defaultValues: formData,
      mode: 'onChange',
      resolver: zodResolver(partnerNameSchema),
    });

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <CapitalDepositQuestionPage
          as="form"
          button={
            <Button
              icon="arrow-right"
              isDisabled={!isValid}
              isLoading={isSending}
              type="submit"
            >
              {locales.ctaSubmit}
            </Button>
          }
          onSubmit={handleSubmit(onSubmit)}
          progress={progress}
        >
          <Header title={locales.title} />

          <Controller
            control={control}
            name="partnerName"
            render={({ field: { onChange, value } }) => (
              <Form.Radio.Group
                display="flex"
                flexDirection="column"
                onChange={onChange}
                radioPosition="right"
                spacing="space-8"
                value={value}
                variant="outline"
              >
                {OPTIONS.map((option) => (
                  <Form.Radio
                    key={option.value}
                    padding="space-16"
                    value={option.value}
                  >
                    <Form.Radio.Title>{option.label}</Form.Radio.Title>
                  </Form.Radio>
                ))}
              </Form.Radio.Group>
            )}
          />
        </CapitalDepositQuestionPage>
      </Layout>
    );
  },
);

export default CapitalDepositPartnerName;
